import { map } from "nanostores"

export interface ConsentSettingsStoreProps {
  is_open: boolean
}

export const $consentSettings = map<ConsentSettingsStoreProps>({
  is_open: false,
})

export const openConsentSettings = () => {
  $consentSettings.setKey("is_open", true)
}

export const closeConsentSettings = () => {
  $consentSettings.setKey("is_open", false)
}
